import { render, staticRenderFns } from "./IsBoundToBudgetBadge.vue?vue&type=template&id=10da64ee&scoped=true"
import script from "./IsBoundToBudgetBadge.vue?vue&type=script&lang=ts"
export * from "./IsBoundToBudgetBadge.vue?vue&type=script&lang=ts"
import style0 from "./IsBoundToBudgetBadge.vue?vue&type=style&index=0&id=10da64ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da64ee",
  null
  
)

export default component.exports